import { type ClassValue, clsx } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";

const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      "font-size": ["text-active-cell", { typo: [() => true] }],
      p: [{ "p-typo": [() => true] }],
      px: [{ "px-typo": [() => true] }],
      py: [{ "py-typo": [() => true] }],
      gap: [{ "gap-typo": [() => true] }],
    },
  },
});

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
